"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ObserveSizing = exports.ObserveDOM = void 0;

var _utils = require("./utils");

var _resizeObserver = require("@juggle/resize-observer");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ResizeObserver = _resizeObserver.ResizeObserver;

var ObserveDOM = /*#__PURE__*/function () {
  function ObserveDOM(el) {
    _classCallCheck(this, ObserveDOM);

    this._domelement = el;

    this._observe();
  }

  _createClass(ObserveDOM, [{
    key: "_observe",
    value: function _observe() {
      var processChildMutations = function processChildMutations(mutations) {
        var _iterator = _createForOfIteratorHelper(mutations),
            _step;

        try {
          var _loop = function _loop() {
            var mutation = _step.value;
            var index = -1;

            if (mutation.type === 'childList') {
              // card added
              if (mutation.addedNodes.length && mutation.addedNodes[0].nodeType === 1 && mutation.addedNodes[0].classList.contains('osb_griditem')) {
                var addedCard = mutation.addedNodes[0];
                index = Array.from(mutation.target.children).indexOf(addedCard);

                _utils.ModuleEventManager.dispatch('addcard', {
                  data: index
                });
              } // card removed
              else if (mutation.removedNodes.length && mutation.removedNodes[0].nodeType === 1 && mutation.removedNodes[0].classList.contains('osb_griditem')) {
                  var getIndex = function getIndex() {
                    if (mutation.previousSibling !== null) {
                      return mutation.previousSibling.nextElementSibling !== null ? Array.from(mutation.target.children).indexOf(mutation.previousSibling.nextElementSibling) : mutation.target.children.length;
                    } else {
                      return 0;
                    }
                  };

                  index = getIndex();

                  _utils.ModuleEventManager.dispatch('removecard', {
                    data: index
                  });
                }
            }
          };

          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      };

      var mutationObserver = new MutationObserver(processChildMutations);
      mutationObserver.observe(this._domelement, {
        attributes: true,
        characterData: true,
        childList: true,
        subtree: true,
        attributeOldValue: true,
        characterDataOldValue: true
      });
    }
  }]);

  return ObserveDOM;
}();

exports.ObserveDOM = ObserveDOM;

var ObserveSizing = /*#__PURE__*/function () {
  function ObserveSizing(el, _this) {
    _classCallCheck(this, ObserveSizing);

    this._domelement = el;
    this._card = _this;

    this._observe();
  }

  _createClass(ObserveSizing, [{
    key: "_observe",
    value: function _observe() {
      var _this2 = this;

      var processHeightChanges = function processHeightChanges(entries) {
        var _iterator2 = _createForOfIteratorHelper(entries),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var entry = _step2.value;

            if (entry.contentBoxSize) {
              _utils.ModuleEventManager.dispatch('mutationevent', {
                data: _this2._card.cardindex
              });
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      };

      var resizeObserver = new ResizeObserver(processHeightChanges);
      resizeObserver.observe(this._domelement);
    }
  }]);

  return ObserveSizing;
}();

exports.ObserveSizing = ObserveSizing;